export enum ActTypesEnum {
  KNM_ACT = 1,
  KNM_ACT_IMPOSSIBLE = 2,
  PM_PROF_ACT = 3,
  PM_PROF_ACT_IMPOSSIBLE = 4,
}
